import WorkflowGuideAnchor from './WorkflowGuideAnchor.component';

export default WorkflowGuideAnchor;
